import { useCallback, useEffect, useState } from 'react';

import { useStatsigClient } from '@statsig/react-bindings';

export const useFeatureGate = (gateKey: string) => {
  const { client } = useStatsigClient();
  const [isEnabled, setIsEnabled] = useState(() => (client ? client.checkGate(gateKey) : false));

  const evaluate = useCallback(() => {
    setIsEnabled(client ? client.checkGate(gateKey) : false);
  }, [client, gateKey]);

  useEffect(() => {
    if (!client) return;

    const refreshGate = async () => {
      try {
        await client.updateUserAsync(client.getContext().user);
      } finally {
        evaluate();
      }
    };

    refreshGate();
  }, [client, evaluate]);

  return { isEnabled, refresh: evaluate };
};
